module.exports = __webpack_public_path__ + "img/RU.e2037a0e.svg";